import { Heading, LottieAnimation, InlineLink } from '~/components'
import { getLottieFile } from '~/utils'

const MaintenancePage = () => {
  const lottieError = getLottieFile('order-problem')

  return (
    <div className="container py-20">
      <div className="mx-auto rounded-2xl bg-neutral-100 p-6 text-center md:w-7/12 lg:w-6/12 lg:p-10 xl:w-5/12">
        {lottieError && (
          <div className="mx-auto mb-2 size-44">
            <LottieAnimation data={lottieError} />
          </div>
        )}
        <Heading
          tag="h1"
          size="h4"
          semiBold
          bold={false}
        >
          Site under maintenance
        </Heading>
        <p>
          We are currently undergoing scheduled maintenance on the website.
          Please bear with us and we will have things back up and running
          shortly!
        </p>
        <p className="mb-3">
          If you have an urgent enquiry please contact us via &nbsp;
          <InlineLink
            to="mailto:onlinesupport@hss.com"
            label="onlinesupport@hss.com"
          />
          &nbsp;or&nbsp;
          <InlineLink
            to="tel:03456088811"
            label="0345 608 8811"
          />
          .
        </p>
      </div>
    </div>
  )
}

export default MaintenancePage
